import retention from "@/api/retention";

const state = {
  proformaInvoiceData: {},
  isFetchProformaInvoiceDataLoading: false,
  isFetchProformaInvoiceDataError: false,
  isFetchProformaInvoiceDataErrorResponse: null,

  isDownloadProformaInvoiceDataLoading: false,
  isDownloadProformaInvoiceDataError: false,
  isDownloadProformaInvoiceDataErrorResponse: null,
};

const mutations = {
  FETCH_PROFORMA_INVOICE_BEGIN(state) {
    state.isFetchProformaInvoiceDataLoading = true;
    state.isFetchProformaInvoiceDataError = false;
    state.isFetchProformaInvoiceDataErrorResponse = null;
  },
  FETCH_PROFORMA_INVOICE_SUCCESS(state, payload) {
    state.proformaInvoiceData = payload;
    state.isFetchProformaInvoiceDataLoading = false;
  },
  FETCH_PROFORMA_INVOICE_ERROR(state, err) {
    state.isFetchProformaInvoiceDataLoading = false;
    state.isFetchProformaInvoiceDataError = true;
    state.isFetchProformaInvoiceDataErrorResponse = err;
  },

  DOWNLOAD_PROFORMA_INVOICE_BEGIN(state) {
    state.isDownloadProformaInvoiceDataLoading = true;
    state.isDownloadProformanvoiceDataError = false;
    state.isDownloadProformaInvoiceDataErrorResponse = null;
  },
  DOWNLOAD_PROFORMA_INVOICE_SUCCESS(state) {
    state.isDownloadProformaInvoiceDataLoading = false;
  },
  DOWNLOAD_PROFORMA_INVOICE_ERROR(state, err) {
    state.isDownloadProformaInvoiceDataLoading = false;
    state.isDownloadProformaInvoiceDataError = true;
    state.isDownloadProformaInvoiceDataErrorResponse = err;
  }
};

const actions = {
  async fetchProformaInvoiceData({ commit }, leadId) {
    commit("FETCH_PROFORMA_INVOICE_BEGIN");
    try { 
      const response = await retention.fetchProformaInvoiceData(leadId);
      commit("FETCH_PROFORMA_INVOICE_SUCCESS", response.data);
    } catch(err) {
      commit("FETCH_PROFORMA_INVOICE_ERROR", err.response.data);
    }
  },

  async downloadProformaInvoice({ commit }, accountId) {
    commit("DOWNLOAD_PROFORMA_INVOICE_SUCCESS");
    try { 
      const res = await retention.downloadProformaInvoice(accountId);
      const url = window.URL.createObjectURL(res.data);
      const link = document.createElement('a');
      link.href = url;
      let date = new Date();
      link.download = `proforma-invoice-${date.toISOString()}.pdf`;
      document.body.appendChild(link);
      link.click();
      window.URL.revokeObjectURL(url);
      commit("DOWNLOAD_PROFORMA_INVOICE_SUCCESS");
    } catch(err) {
      commit("DOWNLOAD_PROFORMA_INVOICE_ERROR", err.response.data);
    }
  },
};

const getters = {
  getProformaInvoiceData: state => state.proformaInvoiceData,
  getIsFetchProformaInvoiceDataLoading: state => state.isFetchProformaInvoiceDataLoading,
  getIsFetchProformaInvoiceDataError: state => state.isFetchProformaInvoiceDataError,
  getIsFetchProformaInvoiceDataErrorResponse: state => state.isFetchProformaInvoiceDataErrorResponse,
  
  getIsDownloadProformaInvoiceDataLoading: state => state.isUpdateProformaInvoiceDataLoading,
  getIsDownloadProformaInvoiceDataError: state => state.isUpdateProformaInvoiceDataError,
  getIsDownloadProformaInvoiceDataErrorResponse: state => state.isUpdateProformaInvoiceDataErrorResponse,
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
